// eslint-disable-next-line import/prefer-default-export
export const maskPhone = (phoneString: string = ''): string => {
  const areaCode: string = phoneString.substring(0, 3)
  const phoneSegment1: string = phoneString.substring(3, 6)
  const phoneSegment2: string = phoneString.substring(6, 10)
  const maskedPhone: string = `(${areaCode}) ${phoneSegment1}-${phoneSegment2}`

  return maskedPhone
}
